import { render, staticRenderFns } from "./ArtistsSpan.vue?vue&type=template&id=7560a804&scoped=true&"
import script from "./ArtistsSpan.vue?vue&type=script&lang=js&"
export * from "./ArtistsSpan.vue?vue&type=script&lang=js&"
import style0 from "./ArtistsSpan.vue?vue&type=style&index=0&id=7560a804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560a804",
  null
  
)

export default component.exports